import { render, staticRenderFns } from "./bbsDialog.vue?vue&type=template&id=bdd01b66&scoped=true"
import script from "./bbsDialog.vue?vue&type=script&lang=js"
export * from "./bbsDialog.vue?vue&type=script&lang=js"
import style0 from "./bbsDialog.vue?vue&type=style&index=0&id=bdd01b66&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdd01b66",
  null
  
)

export default component.exports